import { ContactData } from 'src/Libs/user/models'
import { UserAction, UserData, Company, UserActionType } from './UserModel'

/**
 * updates user data
 */
export const updateUserData = (userData: Partial<UserData>): UserAction => {
  return { type: UserActionType.updateUserData, userData }
}

/**
 * sets user data to empty object
 */
export const resetUserData = (): UserAction => {
  return { type: UserActionType.resetUserData }
}

/**
 * updates user data
 */
export const updateContactData = (contactData: ContactData): UserAction => {
  return { type: UserActionType.updateContactData, contactData }
}

/**
 * sets user data to empty object
 */
export const resetContactData = (): UserAction => {
  return { type: UserActionType.resetContactData }
}

export const updateCompanyAddress = (company: Company): UserAction => {
  return { type: 'UPDATE_COMPANY_ADDRESS', company }
}
